<template>
    <vue-scroll v-if="corporation">
        <single :corporation="corporation" ref="single" />
    </vue-scroll>
</template>

<script>
import Single from "./Single";
import store from "../../../store/index";
import unsaved_changes_mixin from "../../../mixins/unsaved-changes";

export default {
    mixins: [unsaved_changes_mixin],
    components: {
        Single,
    },
    beforeRouteEnter(to, from, next) {
        axios
            .get(`/web-api/corporation/${to.params.id}`, {
                params: {
                    include: store.state.corporations.meta.include,
                },
            })
            .then((response) => {
                next((vm) => vm.setData(response));
            });
    },
    data() {
        return {
            corporation: null,
        };
    },
    computed: {
        hasChanges() {
            return _.get(this.$refs, "single.hasChanges");
        },
    },
    methods: {
        setData(response) {
            this.corporation = response.data;
        },
    },
};
</script>

<style scoped></style>
